/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  CardHeader,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { filterLoans } from 'src/store/actions/loans.action';
import LoanList from 'src/components/loans/LoanList';
import HelmetSeo from '../components/HelmetSeo';
import appConfig from '../config';
import { filterUsers } from '../store/actions/users.action';
import UserListTable from '../components/users/UserListTable';

export default function Loans() {
  const dispatch = useDispatch();
  const { loanListStatus } = useSelector((state) => state.loans);
  const { loanTypes, userStatuses } = useSelector((state) => state.app);
  const authState = useSelector((state) => state.authentication);
  const { user } = authState;

  const [loans, setLoans] = useState([]);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filter, setFilter] = useState({
    page: 1,
    pageSize: appConfig.pagination.pageSize,
    loanTypeId: null,
    userId: user.id || '',
  });

  const fetchLoans = async (payload) => {
    try {
      const response = await dispatch(filterLoans(payload)).unwrap();

      if (response) {
        if (response.pagination) {
          setTotalCount(response.pagination.total);
          setTotalPages(response.pagination.totalPages);
        }

        setLoans(response.data);
        console.log('Downloaded: ', response.data);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const onPageChange = (event, newPage) => {
    const newFilter = { ...filter, page: newPage };
    setFilter(newFilter);
    fetchLoans(newFilter);
  };

  //   const onRowsPerPageChange = (event) => {
  //     const limit = event.target.value;

  //     const newFilter = { ...filter, pageSize: limit };
  //     setFilter(newFilter);
  //     fetchLoans(newFilter);
  //   };

  const handleLoanTypeChange = (event) => {
    const loanTypeId = event.target.value;
    const newFilter = { ...filter, loanTypeId };
    setFilter(newFilter);
    fetchLoans(newFilter);
  };

  //   const handleStatusChange = (event) => {
  //     const statusId = event.target.value;
  //     const newFilter = { ...filter, statusId };
  //     setFilter(newFilter);
  //     fetchLoans(newFilter);
  //   };

  useEffect(() => {
    fetchLoans(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <>
      <HelmetSeo title="Users | Rewot Ciro" />

      <Box sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
      }}
      >
        <Card>
          <CardHeader title="Loans" />
          <Divider />

          <Grid
            container
            spacing={1}
            sx={{ mt: 2, mb: 2 }}
          >
            <Grid item xs={12}>
              <Stack direction="row" spacing={3} sx={{ height: 56, m: 2 }}>
                {/* <TextField
                  select
                  label="Select Status"
                  onChange={(e) => handleStatusChange(e)}
                  sx={{ minWidth: 250 }}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>

                  {userStatuses.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField> */}

                <TextField
                  select
                  label="Select Loan Type"
                  onChange={(e) => handleLoanTypeChange(e)}
                  sx={{ minWidth: 250 }}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>

                  {loanTypes.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>

              </Stack>
            </Grid>
          </Grid>

          <Divider />

          <LoanList loading={loanListStatus === 'loading'} loans={loans} />

          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-end"
            sx={{ mt: 4, mb: 5 }}
          >

            {/* <TablePagination
                component="div"
                count={totalCount}
                page={filter.page}
                onPageChange={onPageChange}
                rowsPerPage={filter.pageSize}
                onRowsPerPageChange={onRowsPerPageChange}
              /> */}

            <Pagination
              count={totalPages}
              color="primary"
              defaultPage={1}
              showFirstButton
              showLastButton
              onChange={onPageChange}
            />

          </Grid>
        </Card>
      </Box>
    </>
  );
}
